<template>
  <a role="button" class="whitespace-nowrap text-sm" @click="showEditRoleDialog">Edit</a>
</template>

<script>
export default {
  props: {
    role: {
      type: Object,
      required: true,
    },
  },
  methods: {
    showEditRoleDialog() {
      this.$modal.show({
        component: () => import('./EditRoleDialog.vue'),
        props: {
          roleId: this.role.id,
        },
        on: {
          updated: () => {
            this.$emit('updated');
          },
        },
        hideEvent: 'close',
      });
    },
  },
};
</script>
